import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import account from './account'
import organization from './organization'
import system from './system'
import search from './search'
import lot from './lot'
import tender from './tender'
import catalog from './catalog'
import publicLot from './public-lot'
import publicTender from './public-tender'
import retend from './retend'
import lotDiscussion from './public-lot-discussion'
import messages from './messages'
import news from './news'
import reports from './reports'
import settings from './settings'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    account,
    organization,
    system,
    search,
    lot,
    tender,
    catalog,
    publicLot,
    publicTender,
    retend,
    lotDiscussion,
    messages,
    news,
    reports,
    settings
  },

  state: {
    error: undefined
  },

  getters: {
    globalError: s => s.error
  },

  mutations: {
    setGlobalError: (s, error) => { s.error = error }
  },

  actions: {
    raiseGlobalError({commit}, error) {
      commit('setGlobalError', error)
    },

    hideGlobalError({commit}) {
      commit('setGlobalError', undefined)
    }
  }
})
